import { adminHttpClient } from '../../../../../commons/adminHttpClient'
import { PerksCategoriesWithExpenseResponse } from './getCategoriesWithExpenseTypes'

export type PerksCategoriesWithExpenseRequest = {
  perkCategoryId: number
  expenseTypes: number[]
  startDate: string
  endDate: string
  amount: number
  allowanceFrequency: number
  productClassId: string
}

export const addNewPerk = (
  request: PerksCategoriesWithExpenseRequest,
): Promise<PerksCategoriesWithExpenseResponse[]> => {
  return adminHttpClient.post(`/AdminDashboard/Perks/AddNewPerk`, request)
}
